import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

type ProgressBarComponentType = {
  styleOverrides: {
    root: () => Record<string, unknown>;
  };
};

export const getProgressBarOptions = ({
  palette,
}: Theme): { progressBarComponent: ProgressBarComponentType } => {
  const progressBarComponent = {
    styleOverrides: {
      root: () => {
        return {
          flex: 1,
          height: '4px',
          borderRadius: '2px',
          backgroundColor: palette.header.progressBar.main,

          [`& ${globalClasses.MuiLinearProgressBar}`]: {
            backgroundColor: palette.header.progressBar.mainFilled,
          },
        };
      },
    },
  };

  return { progressBarComponent };
};
